module.exports = __webpack_public_path__ + "static/media/icon_user_2.6abe2b3b.svg";